var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoArbor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F7F8FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2344_1885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8667 14.5H16.1333C14.9551 14.5 14 15.4551 14 16.6333V44.3667C14 45.5449 14.9551 46.5 16.1333 46.5H43.8667C45.0449 46.5 46 45.5449 46 44.3667V16.6333C46 15.4551 45.0449 14.5 43.8667 14.5Z",
    fill: "#4C5288"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0625 38.75L30.0404 21.6875L22.9375 38.6644",
    fill: "#4C5288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0625 38.75L30.0404 21.6875L22.9375 38.6644",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2344_1885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoArbor);
export default __webpack_public_path__ + "static/media/logo-arbor.3e972b52e2b46854aed39d94435ad5ae.svg";
export { ForwardRef as ReactComponent };